import { createImpersonationLogApi } from "@services/createImpersonationLogApi";

export const logImpersonationEvent = async ({
  loggedInUser,
  impersonatedTo,
}) => {
  try {
    await createImpersonationLogApi(loggedInUser, impersonatedTo);
  } catch (e) {
    console.error("Failed to log impersonation event", e);
  }
};
